import { useEffect, useState } from "react";

export const useDebounced = (value, delay = 400) => {
  const [stateValue, setStateValue] = useState(value);
  useEffect(() => {
    const timeouts = setTimeout(() => setStateValue(value), delay);
    return () => clearTimeout(timeouts);
  }, [value, delay]);
  return stateValue;
};